import Adora1 from '../../../Media/BSD/Terravia/Terravia Adora.webp'
import Adora2 from '../../../Media/BSD/Terravia/Terravia Adora.webp'





const Adoraimages =[
Adora1,Adora2
]

export default Adoraimages;